<!-- 步进器组件 临时封装需要完善-->
<template>
  <div>
    <div class="main">
      <div
        v-if="min < num"
        class="stepperBtn delete"
        @click="Steppernum('delete')"
      >
        <img
          class="minus-icon"
          src="../../../../static/img/meals/icon_sc.png"
        />
      </div>

      <input type="text" v-model="num" @change="changeVal" />

      <div
        v-if="num < max"
        class="stepperBtn"
        :class="{ blockW: num > max && num === max }"
        @click="Steppernum('add')"
      >
        <img class="add-icon" src="../../../../static/img/meals/icon_tj.png" />
      </div>
      <div v-if="num > max || num === max" class="blockW"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 999,
    },
    propValue: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      num: 1,
    };
  },
  methods: {
    Steppernum(type) {
      if (type === "add") {
        if (this.num === this.max) {
          return;
        }
        this.num = ++this.num;
      } else {
        if (this.num === this.min) {
          return;
        }
        this.num = --this.num;
      }
      this.$emit("changeShop", this.num);
    },
    changeVal(e) {
      let flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value);
      if (!flag) {
        this.num = 1;
      }
      if (e.target.value > 999) {
        this.num = 999;
      }
      if (e.target.value > 1 && e.target.value <= 999) {
        this.$emit("changeShop", e.target.value);
      }
    },
  },
};
</script>
<style lang='less' scoped>
@background: #ccc;

.main {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  input {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 40px;
    text-align: center;
    height: 30px;
    border: 0;
    font-size: 16px;
  }
  .stepperBtn {
    &:hover {
      cursor: pointer;
    }
  }
  .delete {
    width: 24px;
    height: 27px;
    font-size: 12px;
    font-weight: bold;
  }
  .blockW {
    width: 25px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/coffee/components/Stepper.vue